<template>

  <b-skeleton v-if="!loaded" height="91px"></b-skeleton>

  <div class="riga-card" v-else>
    <div v-if="!tipo" :class="'col-custom-' + (specs.length + 2) + ' codart'">
      {{ codart }}
    </div>
    <div v-if="!tipo" :class="'col-custom-' + (specs.length + 2)">
      <span style="color: indianred">Specifiche non trovate</span>
    </div>
    <div v-if="tipo" :class="'col-custom-' + (specs.length + 2) + ' codart'">
      {{ codart }}
    </div>
    <div v-if="specs.length > 0" :class="'col-custom-' + (specs.length + 2)" v-for="sp in specs">
      {{ sp.contenuto }}
    </div>
    <div v-if="tipo" :class="'col-custom-' + (specs.length + 2) + ' dld'">
      <img @click="getAllegato()" :src="url('/storage/media/icons/download.svg')"
           alt="download icon">
    </div>

  </div>
</template>

<script>
export default {
  name: "product-detail-card",
  props: ['codart', 'index', 'annotation'],
  data() {
    return {
      loaded: false,
      specs: [],
      tipo: null,
      allegatoExist: false,
      fileBase64: null,
      estensione: null,
    }
  },
  mounted() {
    // if (this.annotation) {
    //   this.checkExistAllegato()
    // }
    this.getSpecs()
  },
  methods: {
    checkExistAllegato() {
      axios({
        method: 'get',
        url: window.location.origin + '/catalog/api/getAllegato',
        params: {
          cod_art: this.annotation.cod_art,
          id_allegato: this.annotation.id_allegato,
        }
      }).then(res => {
        if (res.data.allegato.base64) {
          this.allegatoExist = true
          this.fileBase64 = res.data.allegato.base64
          this.estensione = res.data.allegato.estensione
        }

      })
    },
    getAllegato() {

      // if (this.fileBase64) {
      //   let link = document.createElement("a");
      //   document.body.appendChild(link);
      //   link.setAttribute("type", "hidden");
      //   // settaggio dell'href (in questo caso il base64, non è un link) + nome del file (abbiamo inserito il datetime nel nome dell'esportazione)
      //   link.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + this.fileBase64;
      //   link.download = this.codart + '_' + Date.now() + this.estensione;
      //   // simulo il click nel link + rimozione del link ad operazione conclusa
      //   link.click();
      //   document.body.removeChild(link);
      //
      // }

      let link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("type", "hidden");
      link.href = window.location.origin + '/storage/media/articles/pdf/' + this.annotation.id_allegato + '.pdf'
      link.download = Date.now() + '_' + this.annotation.id_allegato + '.pdf'
      link.click()
      document.body.removeChild(link)

    },
    getSpecs: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/catalog/api/getspecs',
        params: {
          codart: this.codart
        }
      }).then(res => {
        //console.log(res.data)
        res.data.forEach((el) => {
          // if (el.id_ref_etichetta === '100-1' ||
          //     el.id_ref_etichetta === '100-2' ||
          //     el.id_ref_etichetta === '100-3' ||
          //     el.id_ref_etichetta === '100-4' ||
          //     el.id_ref_etichetta === '100-5' ||
          //     el.id_ref_etichetta === '100-6' ||
          //     el.id_ref_etichetta === '100-7' ||
          //     el.id_ref_etichetta === '200-1' ||
          //     el.id_ref_etichetta === '200-2' ||
          //     el.id_ref_etichetta === '200-3' ||
          //     el.id_ref_etichetta === '200-4' ||
          //     el.id_ref_etichetta === '200-5' ||
          //     el.id_ref_etichetta === '200-6' ||
          //     el.id_ref_etichetta === '200-7' ||
          //     el.id_ref_etichetta === '800-1' ||
          //     el.id_ref_etichetta === '800-2' ||
          //     el.id_ref_etichetta === '800-3' ||
          //     el.id_ref_etichetta === '800-4' ||
          //     el.id_ref_etichetta === '800-5' ||
          //     el.id_ref_etichetta === '800-6' ||
          //     el.id_ref_etichetta === '800-7' ||
          //     el.id_ref_etichetta === '900-1' ||
          //     el.id_ref_etichetta === '900-2' ||
          //     el.id_ref_etichetta === '900-3' ||
          //     el.id_ref_etichetta === '900-4' ||
          //     el.id_ref_etichetta === '900-5' ||
          //     el.id_ref_etichetta === '900-6' ||
          //     el.id_ref_etichetta === '900-7' ||
          //     el.id_ref_etichetta === '400-1' ||
          //     el.id_ref_etichetta === '400-2' ||
          //     el.id_ref_etichetta === '400-3' ||
          //     el.id_ref_etichetta === '400-4' ||
          //     el.id_ref_etichetta === '400-5' ||
          //     el.id_ref_etichetta === '400-6' ||
          //     el.id_ref_etichetta === '400-7' ||
          //     el.id_ref_etichetta === '600-1' ||
          //     el.id_ref_etichetta === '600-2' ||
          //     el.id_ref_etichetta === '600-3' ||
          //     el.id_ref_etichetta === '600-4' ||
          //     el.id_ref_etichetta === '600-5' ||
          //     el.id_ref_etichetta === '600-6' ||
          //     el.id_ref_etichetta === '600-7' ||
          //     el.id_ref_etichetta === '500-1' ||
          //     el.id_ref_etichetta === '500-2' ||
          //     el.id_ref_etichetta === '500-3' ||
          //     el.id_ref_etichetta === '500-4' ||
          //     el.id_ref_etichetta === '500-5' ||
          //     el.id_ref_etichetta === '500-6' ||
          //     el.id_ref_etichetta === '500-7'
          // ) {
          let tmpObj = {}
          tmpObj['ref'] = el.id_ref_etichetta
          tmpObj['contenuto'] = el.contenuto
          this.specs.push(tmpObj)
          // }

        })
        if (res.data[0]) {
          this.tipo = res.data[0].cod_tipo
          this.$emit('tipo', res.data[0].cod_tipo)
        }

        this.loaded = true
      })
    }
  },
}
</script>

<style lang="scss" scoped>
$greenprod: #ABC932;
.b-skeleton {
  margin: 5px 0;
}

.riga-card {
  display: flex;
  margin: 7px 0;
  text-align: center;
  width: 100%;
  font-size: 0.9rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }
  padding: 35px 0;
  background-color: rgba(245, 245, 245, 0.05);
  @media (max-width: 576px) {
  }
  //.col-custom {
  //  width: calc(100% / 8);
  //
  //  &.codart {
  //    color: $greenprod;
  //  }
  //
  //  &.dld {
  //    display: flex;
  //    justify-content: center;
  //    cursor: pointer;
  //
  //    img {
  //      height: 80%;
  //    }
  //  }
}

@for $i from 2 through 14 {
  .col-custom-#{$i} {
    width: calc(100% / #{$i});
    text-align: center;
    padding: 0 5px;
    &.codart {
      color: $greenprod;
    }

    &.dld {
      display: flex;
      justify-content: center;
      cursor: pointer;
      img {
        width: 30px;
      }
    }

    @media (max-width: 576px) {
      img {
        width: 25%;
      }
    }
  }
  .col-custom-2, .col-custom-1 {
    width: calc(100% / 8);
  }
}

//.col-custom7 {
//  width: calc(100% / 7);
//
//  &.codart {
//    color: $greenprod;
//  }


</style>
